import { render, staticRenderFns } from "./SakaLabel.vue?vue&type=template&id=cbb97d68"
import script from "./SakaLabel.vue?vue&type=script&lang=js"
export * from "./SakaLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports